import { createFileRoute } from '@tanstack/react-router';
import { ShadowSystemsListPage } from '@/pages/systems/shadow-systems/ShadowSystemsListPage';
import { createCaslGuard } from '@/lib/auth/permissionGuards';

export const Route = createFileRoute('/$slug/systems/shadow-systems')({
  component: ShadowSystemsListPage,
  beforeLoad: createCaslGuard('ShadowSystem')
});
